var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonerArtikkelIntervjuSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikoner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.29,30.17H11.1a.31.31,0,0,1-.31-.31V11.05a.31.31,0,0,1,.31-.31H27.26a.31.31,0,0,1,.31.31V28.49a.31.31,0,0,1-.62,0V11.36H11.41v18.2H26.29a.29.29,0,0,1,.3.3A.3.3,0,0,1,26.29,30.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.08,17.64h-10a.31.31,0,0,1-.31-.31V14.78a.3.3,0,0,1,.31-.3h10a.29.29,0,0,1,.3.3v2.55A.3.3,0,0,1,24.08,17.64ZM14.43,17h9.34V15.09H14.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.89,20.06H14.23a.31.31,0,1,1,0-.62h9.66a.31.31,0,0,1,0,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.89,21.74H14.23a.31.31,0,0,1-.31-.31.3.3,0,0,1,.31-.3h9.66a.3.3,0,0,1,.31.3A.31.31,0,0,1,23.89,21.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.24,23.32h-4.1a.31.31,0,0,1,0-.62h4.1a.31.31,0,1,1,0,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.24,25h-4.1a.29.29,0,0,1-.3-.3.3.3,0,0,1,.3-.31h4.1a.31.31,0,0,1,.31.31A.3.3,0,0,1,18.24,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.24,26.67h-4.1a.31.31,0,0,1,0-.62h4.1a.31.31,0,0,1,0,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.92,23.32h-4.1a.31.31,0,0,1,0-.62h4.1a.31.31,0,1,1,0,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.92,25h-4.1a.3.3,0,0,1-.31-.3.31.31,0,0,1,.31-.31h4.1a.31.31,0,0,1,.31.31A.3.3,0,0,1,23.92,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.92,26.67h-4.1a.31.31,0,0,1,0-.62h4.1a.31.31,0,1,1,0,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,31.68H13v-1.5a.31.31,0,0,1,.31-.31.3.3,0,0,1,.3.31v.88H28a.31.31,0,0,1,0,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.65,30.23a.29.29,0,0,1-.3-.3V13h-.81a.31.31,0,0,1,0-.62H29V29.93A.3.3,0,0,1,28.65,30.23Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonerArtikkelIntervjuSmall);
export default __webpack_public_path__ + "static/media/Ikoner_Artikkel-intervju_small.f78ffda77fbf1265dc1e2bd8cb46e275.svg";
export { ForwardRef as ReactComponent };